import { ReactElement } from 'react'
import BaseLayout from 'src/v3/components/base-layout'
import { useAppSelector } from 'src/store/hooks'
import {
  AssignmentIcon,
  CertificateIcon,
  CredentialIcon,
  IBSCRenewalIcon,
  LearningPathIcon,
  LinkedServiceIcon,
  ProfileIcon,
} from '../core/icons'
import { selectLinkedServices } from '../settings/settings.slice'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => {
  let linkedServices = useAppSelector(selectLinkedServices)

  return (
    <BaseLayout
      children={children}
      domain="profile"
      subMenuItems={[
        {
          name: 'Profile',
          route: '/',
          allowInLimited: true,
          icon: <ProfileIcon />,
        },
        {
          name: 'Assignments',
          route: '/assignments',
          icon: <AssignmentIcon />,
        },
        {
          name: 'Certificates',
          route: '/certificates',
          allowInLimited: true,
          icon: <CertificateIcon />,
        },
        {
          name: 'Credentials',
          route: '/credentials',
          icon: <CredentialIcon />,
        },
        {
          name: 'Learning Paths',
          route: '/learning-paths',
          icon: <LearningPathIcon />,
        },
        {
          name: 'New York Learning Paths',
          route: '/new-york-learning-paths',
          icon: <LearningPathIcon />,
        },
        {
          name: 'Linked Services',
          route: '/linked-services',
          icon: <LinkedServiceIcon />,
        },
        {
          name: 'IBSC 100-Hour',
          route: '/ibsc-100',
          icon: <IBSCRenewalIcon />,
        },
        { name: 'IBSC 40-Hour', route: '/ibsc-40', icon: <IBSCRenewalIcon /> },
      ].filter((item) =>
        item.name === 'Assignments' || item.name === 'Linked Services'
          ? linkedServices.length > 0
          : true,
      )}
    />
  )
}
